<template>
  <div
    :class="isOpen ? 'quick-view open' : 'quick-view'"
    @click.self="closePopup()"
  >
    <div class="quick-view-content" style="width: 900px" v-if="isOpen">
      <div class="bg-white">
        <div class="flex flex-row align-items-center p-2">
          <i
            @click="isOpen = false"
            class="fa fa-arrow-left font-22 pointer mr-3"
          />
          <div v-if="recordId" class="flex flex-1">
            <p class="font-16 bold">Phiếu {{ newObj.code }}</p>
            <p class="sub-text">{{ newObj.isManual ? "" : "Tạo tự động" }}</p>
          </div>
          <p class="font-16 flex flex-1 bold" v-else>
            {{ type == "income" ? "Tạo phiếu thu" : "Tạo phiếu chi" }}
          </p>

          <button class="btn btn-sm btn-secondary mr-2" v-if="recordId">
            In
          </button>
        </div>
      </div>
      <div class="p-2" v-if="tabActive == 'info' && !isEdit">
        <div class="mb-2 text-right">
          <button
            class="btn btn-primary btn-sm"
            @click="isEdit = true"
            v-if="recordId && $permission('ADMIN:FINANCE_UPDATE')"
          >
            <i class="fa fa-edit" /> Chỉnh sửa
          </button>
        </div>

        <div class="box">
          <div class="p-2">
            <div class="box">
              <div class="box-item flex flex-row align-items-center">
                <div class="flex flex-2">
                  <label>Yếu tố thu / chi</label>
                  <p class="">{{ detail.elementName || "-" }}</p>
                </div>
                <div class="flex flex-1">
                  <label>Quyển số</label>
                  <p class="">{{ detail.bookNo || "-" }}</p>
                </div>
                <div class="flex flex-1">
                  <label>Số phiếu</label>
                  <p class="">{{ detail.codeNumber || "-" }}</p>
                </div>
              </div>

              <div class="box-item">
                <label>Tổng tiền</label>
                <p class="bold">{{ $formatMoney(detail.totalPayment) }}</p>
              </div>

              <div class="box-item flex flex-row align-items-center">
                <div class="flex flex-1">
                  <label>Người nhận</label>
                  <p>
                    {{ detail.receiverRepresent }}
                  </p>
                </div>

                <div class="flex flex-1">
                  <label>Người nộp</label>
                  <p>
                    {{ detail.transferRepresent }}
                  </p>
                </div>
              </div>

              <div class="box-item flex flex-row align-items-center">
                <div class="flex flex-1">
                  <label>Đối tượng pháp nhân nhận (nợ)</label>
                  <p>
                    {{ detail.receiver }}
                    <span
                      v-if="
                        detail.accountantType == 'EXPENSE' && detail.address
                      "
                    >
                      ({{ detail.address }})
                    </span>
                  </p>
                  <label> {{ detail.receiverCode }}</label>
                </div>

                <div class="flex flex-1">
                  <label>Đối tượng pháp nhân nộp (có)</label>
                  <p>
                    {{ detail.transfer }}
                    <span
                      v-if="detail.accountantType == 'INCOME' && detail.address"
                    >
                      ({{ detail.address }})
                    </span>
                  </p>
                  <label> {{ detail.transferCode }}</label>
                </div>
              </div>

              <div class="box-item" v-if="detail.description">
                <label>Diễn giải</label>
                <p>{{ detail.description }}</p>
              </div>
            </div>
          </div>
          <div class="p-2">
            <h3 class="font-14 bold">Hạch toán</h3>
            <div
              class="box p-2 mb-1 flex flex-row align-items-center"
              v-for="(payment, index) in detail.payments"
              :key="index"
            >
              <div class="flex flex-1 flex-row">
                <div>
                  <label v-if="payment.receiverCode">{{
                    payment.receiverCode
                  }}</label>
                  <p class="bold">{{ payment.receiver || detail.receiver }}</p>
                  {{
                    payment.debtAcc.detail ? payment.debtAcc.detail.name : ""
                  }}
                  {{
                    payment.debtAcc.detail ? payment.debtAcc.detail.code : ""
                  }}
                </div>
                <i class="fa fa-arrow-left mr-3 ml-3 font-16" />

                <div>
                  <label v-if="payment.transferCode">{{
                    payment.transferCode
                  }}</label>
                  <p class="bold">{{ payment.transfer || detail.transfer }}</p>
                  {{
                    payment.availableAcc.detail
                      ? payment.availableAcc.detail.name
                      : ""
                  }}
                  {{
                    payment.availableAcc.detail
                      ? payment.availableAcc.detail.code
                      : ""
                  }}
                </div>
              </div>
              <p class="bold">{{ $formatMoney(payment.totalPayment) }}</p>
            </div>
          </div>
          <div class="p-2">
            <h3 class="font-14 bold">Thanh toán</h3>

            <div
              class="box p-2 mb-2 flex flex-row align-items-center"
              v-for="(payment, index) in detail.paymentDetails"
              :key="index"
            >
              <div class="flex flex-1">
                <p>{{ payment.isCashPayment ? "Tiền mặt" : "Chuyển khoản" }}</p>
                <p v-if="payment.currencyUnit != $currency" class="sub-text">
                  {{ payment.originalCurrency }} ({{ payment.currencyUnit }} -
                  {{ $formatMoney(payment.exchangePrice) }})
                </p>
              </div>

              <p class="bold">{{ $formatMoney(payment.totalPayment) }}</p>
            </div>
          </div>

          <div class="p-2">
            <h3 class="font-14 bold">Tham khảo</h3>
            <div
              class="box p-2 mb-2 flex flex-row align-items-center"
              v-for="(ref, index) in detail.incomeExpenseRefs"
              :key="index"
            >
              <router-link
                v-if="ref.invoices"
                :to="'/order?code=' + ref.invoices.code"
              >
                Đơn bán #{{ ref.invoices.code }}
              </router-link>
              <router-link
                v-if="ref.purchaseOrders"
                :to="'/stock/purchase/' + ref.purchaseOrders.id"
              >
                Đơn mua #{{ ref.purchaseOrders.code }}
              </router-link>
              <router-link
                v-if="ref.warehouseReceipts"
                :to="'/stock/transfer/' + ref.warehouseReceipts.id"
              >
                Chuyển hàng #{{ ref.warehouseReceipts.code }}
              </router-link>
              <router-link
                v-if="ref.warehouseOutReceipt"
                :to="'/stock/out/' + ref.warehouseOutReceipt.id"
              >
                Xuất hàng #{{ ref.warehouseOutReceipt.code }}
              </router-link>

              <span v-if="ref.employees">
                Nhân viên {{ ref.employees.fullName }}
              </span>
              <span v-if="ref.suppliers">
                Nhà cung cấp {{ ref.suppliers.supplierName }}
              </span>
              <span v-if="ref.customers">
                Khách hàng {{ ref.customers.customerName }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="p-2" v-if="tabActive == 'info' && isEdit">
        <div class="mb-2 d-flex align-items-center">
          <p
            class="flex-fill m-0 bold"
            v-if="isEdit && recordId && !newObj.isManual"
          >
            Tổng thanh toán : {{ $formatMoney(newObj.totalPayment) }}
          </p>

          <div class="flex-fill" v-else />

          <select
            class="form-control w-200px mr-2"
            v-model="newObj.contractId"
            placeholder="Nhập hợp đồng"
          >
            <option value="">Chọn hợp đồng</option>
            <option v-for="a in $contracts" :key="a.id" :value="a.id">
              {{ a.contractCode }} ({{ a.contractName }})
            </option>
          </select>

          <!-- {{ isManual }} -->
          <button
            class="btn btn-primary btn-sm mr-2"
            :disabled="sending"
            @click="onSubmit()"
            v-if="isEdit"
          >
            <i class="mdi mdi-content-save" />
            Lưu phiếu
          </button>

          <button
            class="btn btn-outline-primary btn-sm"
            @click="
              isEdit = false;
              newObj = { ...rawData };
            "
            v-if="recordId && isEdit"
          >
            <i class="fa fa-edit" /> Tắt chỉnh sửa
          </button>
        </div>
        <div class="box mb-2">
          <div class="box-item d-flex">
            <div class="flex flex-2 mr-2">
              <label class="flex flex-1">Yếu tố thu / chi</label>

              <auto-complete
                :disabled="!isEdit"
                v-if="
                  $financeCodes.filter(
                    (a) => a.accountantType == (type || '').toUpperCase()
                  ).length > 0
                "
                :list="
                  $financeCodes.filter(
                    (a) => a.accountantType == (type || '').toUpperCase()
                  )
                "
                v-model="newObj.elementCode"
                @input="
                  newObj.elementName = $financeCodes.find(
                    (a) => a.id == newObj.elementCode
                  ).name
                "
                placeholder="Yếu tố chi phí"
                class="w-100"
              >
                <div slot="item" slot-scope="{ item }">
                  <label>{{ item.code }}</label>
                  <p>{{ item.name }}</p>
                </div>
              </auto-complete>
              <input
                :disabled="!isEdit"
                v-else
                v-model="newObj.elementName"
                @input="newObj.elementCode = newObj.elementName"
                placeholder="Yếu tố chi phí"
                class="form-control"
              />
            </div>
            <div class="flex flex-1 mr-2">
              <label class="flex flex-1">Quyển số</label>
              <input
                :disabled="!isEdit"
                class="form-control"
                v-model="newObj.bookNo"
                placeholder="Quyển số"
              />
            </div>
            <div class="flex flex-1">
              <label class="flex flex-1">Số phiếu</label>
              <input
                :disabled="!isEdit"
                class="form-control"
                v-model="newObj.codeNumber"
                placeholder="Số phiếu"
              />
            </div>
          </div>
          <div class="box-item d-flex">
            <div class="flex flex-1">
              <label class="flex flex-1">Người nhận đại diên</label>

              <input
                class="form-control"
                :disabled="!isEdit"
                v-model="newObj.receiverRepresent"
                key="free"
                placeholder="Nhập tên người nhận"
              />
            </div>
            <div class="flex flex-10px" />

            <div class="flex flex-1">
              <label class="flex flex-1">Người nộp đại diên</label>

              <input
                class="form-control"
                :disabled="!isEdit"
                v-model="newObj.transferRepresent"
                key="free"
                placeholder="Nhập tên người nộp"
              />
            </div>
          </div>

          <div class="box-item d-md-flex">
            <div class="flex flex-1">
              <label>Đối tượng pháp nhân nhận (nợ)</label>
              <div class="d-flex w-100 align-items-center">
                <span
                  v-for="t in types"
                  :key="t.key"
                  class="tag tag-sm pointer"
                  @click="
                    newObj.receiverType = t.key;
                    newObj.receiver = '';
                    newObj.receiverId = '';
                    newObj.receiverCode = '';
                  "
                  :class="{
                    'tag-primary': t.key == newObj.receiverType,
                    'opacity-50 pe-none': !isEdit,
                  }"
                >
                  {{ t.name }}
                </span>
              </div>
              <input
                v-if="newObj.receiverType == ''"
                :disabled="!isEdit"
                class="form-control"
                v-model="newObj.receiver"
                placeholder="Nhập tên"
                @input="
                  newObj.receiverCode = newObj.receiver;
                  newObj.receiverRepresent = newObj.receiver;
                "
                key="free"
              />
              <auto-complete
                :list="employees"
                v-if="newObj.receiverType == 'employee'"
                v-model="newObj.receiverId"
                :disabled="!isEdit"
                @input="
                  newObj.receiver = employees.find(
                    (a) => a.id == newObj.receiverId
                  ).name;
                  newObj.receiverCode = employees.find(
                    (a) => a.id == newObj.receiverId
                  ).code;
                  newObj.receiverRepresent = newObj.receiver;
                "
                key="employee"
                placeholder="Chọn nhân viên"
                class="w-100"
              >
                <div slot="item" slot-scope="{ item }">
                  <label>{{ item.code }}</label>
                  <p>{{ item.name }}</p>
                </div>
              </auto-complete>
              <auto-complete
                :list="$suppliers"
                :disabled="!isEdit"
                v-if="newObj.receiverType == 'supplier'"
                v-model="newObj.receiverId"
                @input="
                  newObj.receiver = $suppliers.find(
                    (a) => a.id == newObj.receiverId
                  ).name;

                  newObj.receiverCode = $suppliers.find(
                    (a) => a.id == newObj.receiverId
                  ).supplierCode;

                  newObj.receiverRepresent = newObj.receiver;
                "
                placeholder="Chọn nhà cung cấp"
                key="supplier"
                class="w-100"
              >
                <div slot="item" slot-scope="{ item }">
                  <label>{{ item.supplierCode }}</label>
                  <p>{{ item.name }}</p>
                </div>
              </auto-complete>
              <input
                v-if="newObj.receiverType == 'customer'"
                v-model="newObj.receiver"
                :disabled="!isEdit"
                placeholder="Chọn khách hàng"
                key="customer"
                class="form-control"
                @focus="selectCustomer('receiver')"
              />
              <auto-complete
                :list="$customerCompanies"
                v-if="newObj.receiverType == 'customerCompany'"
                v-model="newObj.receiverId"
                :disabled="!isEdit"
                @input="
                  newObj.receiver = $customerCompanies.find(
                    (a) => a.id == newObj.receiverId
                  ).name;

                  newObj.receiverCode = $customerCompanies.find(
                    (a) => a.id == newObj.receiverId
                  ).code;
                  newObj.receiverRepresent = newObj.receiver;
                "
                placeholder="Chọn cty khách hàng"
                class="w-100"
                key="customerCompany"
              >
                <div slot="item" slot-scope="{ item }">
                  <label>{{ item.code }}</label>
                  <p>{{ item.name }}</p>
                </div>
              </auto-complete>
              <check-box
                :disabled="!isEdit"
                v-model="newObj.sameReceiver"
                title="Cùng đối tượng"
                class="mt-1"
              />
            </div>

            <div
              class="flex flex-80px align-items-center justify-content-center"
            >
              <i class="fa fa-arrow-left font-22" />
            </div>

            <div class="flex flex-1">
              <label>Đối tượng pháp nhân nộp (có)</label>
              <div class="d-flex w-100 align-items-center">
                <span
                  v-for="t in types"
                  :key="t.key"
                  class="tag tag-sm pointer"
                  @click="
                    newObj.transferType = t.key;
                    newObj.transferId = '';
                    newObj.transfer = '';
                    newObj.transferCode = '';
                  "
                  :class="{
                    'tag-primary': t.key == newObj.transferType,
                    'opacity-50 pe-none': !isEdit,
                  }"
                >
                  {{ t.name }}
                </span>
              </div>
              <input
                v-if="!newObj.transferType"
                class="form-control"
                :disabled="!isEdit"
                v-model="newObj.transfer"
                @input="
                  newObj.transferCode = newObj.transfer;
                  newObj.transferRepresent = newObj.transfer;
                "
                key="free"
                placeholder="Nhập tên"
              />
              <auto-complete
                :disabled="!isEdit"
                :list="employees"
                @input="
                  newObj.transfer = employees.find(
                    (a) => a.id == newObj.transferId
                  ).name;
                  newObj.transferCode = employees.find(
                    (a) => a.id == newObj.transferId
                  ).code;
                  newObj.transferRepresent = newObj.transfer;
                "
                v-if="newObj.transferType == 'employee'"
                v-model="newObj.transferId"
                placeholder="Chọn nhân viên"
                key="employee"
                class="w-100"
              >
                <div slot="item" slot-scope="{ item }">
                  <label>{{ item.code }}</label>
                  <p>{{ item.name }}</p>
                </div>
              </auto-complete>

              <auto-complete
                :list="$suppliers"
                :disabled="!isEdit"
                v-if="newObj.transferType == 'supplier'"
                v-model="newObj.transferId"
                @input="
                  newObj.transfer = $suppliers.find(
                    (a) => a.id == newObj.transferId
                  ).name;

                  newObj.transferCode = $suppliers.find(
                    (a) => a.id == newObj.transferId
                  ).supplierCode;
                  newObj.transferRepresent = newObj.transfer;
                "
                placeholder="Chọn nhà cung cấp"
                class="w-100"
                key="supplier"
              >
                <div slot="item" slot-scope="{ item }">
                  <label>{{ item.supplierCode }}</label>
                  <p>{{ item.name }}</p>
                </div>
              </auto-complete>

              <input
                :disabled="!isEdit"
                v-if="newObj.transferType == 'customer'"
                v-model="newObj.transfer"
                placeholder="Chọn khách hàng"
                key="customer"
                class="form-control"
                @focus="selectCustomer('transfer')"
              />
              <auto-complete
                :disabled="!isEdit"
                :list="$customerCompanies"
                v-if="newObj.transferType == 'customerCompany'"
                v-model="newObj.transferId"
                @input="
                  newObj.transfer = $customerCompanies.find(
                    (a) => a.id == newObj.transferId
                  ).name;

                  newObj.transferCode = $customerCompanies.find(
                    (a) => a.id == newObj.transferId
                  ).code;
                  newObj.transferRepresent = newObj.transfer;
                "
                placeholder="Chọn cty khách hàng"
                class="w-100"
                key="customerCompany"
              >
                <div slot="item" slot-scope="{ item }">
                  <label>{{ item.code }}</label>
                  <p>{{ item.name }}</p>
                </div>
              </auto-complete>

              <check-box
                :disabled="!isEdit"
                v-model="newObj.sameTransfer"
                title="Cùng đối tượng"
                class="mt-1"
              />
            </div>
          </div>
          <div class="d-flex box-item">
            <div class="flex flex-2 mr-2">
              <label> Thông tin / Địa chỉ pháp nhân </label>
              <input
                class="form-control"
                v-model="newObj.address"
                :disabled="!isEdit"
                placeholder="Thông tin / Địa chỉ pháp nhân "
              />
            </div>
            <div class="flex flex-1 mr-2">
              <label class="">Ngày giao dịch</label>
              <date-picker
                :disabled="!isEdit"
                class="w-100"
                v-model="newObj.startDate"
                placeholder="Ngày giao dịch"
              />
            </div>
          </div>
          <div class="box-item">
            <label>Diễn dải</label>
            <textarea
              :disabled="!isEdit"
              class="form-control"
              v-model="newObj.description"
            />
          </div>
        </div>
        <div class="box">
          <div>
            <div class="box-headline d-flex align-items-center">
              <p class="bold flex flex-1">Thông tin hạch toán</p>

              <a @click="addPayment()" class="text-primary" v-if="isEdit">
                + Thêm mới
              </a>
            </div>
            <div
              class="box-item d-md-flex align-items-end"
              v-for="(payment, index) in newObj.payments"
              :key="index"
            >
              <i
                v-if="newObj.payments.length > 1"
                @click="
                  newObj.payments = newObj.payments.filter(
                    (i, idx) => idx != index
                  );
                  countPrice(true);
                "
                class="fa fa-trash pointer text-danger pr-2 font-22"
              />

              <div class="flex flex-1">
                <label>ĐTPN nhận (nợ)</label>
                <div class="d-flex w-100 align-items-center">
                  <span
                    v-for="t in types"
                    :key="t.key"
                    :class="{
                      'opacity-50 pe-none': newObj.sameReceiver,
                      'tag-primary': t.key == payment.receiverType,
                    }"
                    class="tag tag-sm pointer"
                    @click="
                      payment.receiverType = t.key;
                      payment.receiver = '';
                      payment.receiverId = '';
                      payment.receiverCode = '';
                      $forceUpdate();
                    "
                  >
                    {{ t.name }}
                  </span>
                </div>
                <input
                  v-if="payment.receiverType == ''"
                  class="form-control"
                  v-model="payment.receiver"
                  @input="payment.receiverCode = payment.receiver"
                  placeholder="Nhập tên"
                  :disabled="newObj.sameReceiver"
                  key="free"
                />
                <auto-complete
                  :list="employees"
                  v-if="payment.receiverType == 'employee'"
                  v-model="payment.receiverId"
                  @input="
                    payment.receiver = employees.find(
                      (a) => a.id == payment.receiverId
                    ).name;
                    payment.receiverCode = employees.find(
                      (a) => a.id == payment.receiverId
                    ).code;
                  "
                  key="employee"
                  :disabled="newObj.sameReceiver"
                  placeholder="Chọn nhân viên"
                  class="w-100"
                >
                  <div slot="item" slot-scope="{ item }">
                    <label>{{ item.code }}</label>
                    <p>{{ item.name }}</p>
                  </div>
                </auto-complete>

                <auto-complete
                  :list="$suppliers"
                  v-if="payment.receiverType == 'supplier'"
                  v-model="payment.receiverId"
                  @input="
                    payment.receiver = $suppliers.find(
                      (a) => a.id == payment.receiverId
                    ).name;
                    payment.receiverCode = $suppliers.find(
                      (a) => a.id == payment.receiverId
                    ).supplierCode;
                  "
                  :disabled="newObj.sameReceiver"
                  placeholder="Chọn nhà cung cấp"
                  key="supplier"
                  class="w-100"
                >
                  <div slot="item" slot-scope="{ item }">
                    <label>{{ item.supplierCode }}</label>
                    <p>{{ item.name }}</p>
                  </div>
                </auto-complete>
                <input
                  v-if="payment.receiverType == 'customer'"
                  v-model="payment.receiver"
                  :disabled="newObj.sameReceiver"
                  placeholder="Chọn khách hàng"
                  key="customer"
                  class="form-control"
                  @focus="selectCustomer('receiver', payment)"
                />

                <auto-complete
                  :list="$customerCompanies"
                  v-if="payment.receiverType == 'customerCompany'"
                  v-model="payment.receiverId"
                  @input="
                    payment.receiver = $customerCompanies.find(
                      (a) => a.id == payment.receiverId
                    ).name;
                    payment.receiverCode = $customerCompanies.find(
                      (a) => a.id == payment.receiverId
                    ).supplierCode;
                  "
                  placeholder="Chọn cty khách hàng"
                  key="customerCompany"
                  :disabled="newObj.sameReceiver"
                  class="w-100"
                >
                  <div slot="item" slot-scope="{ item }">
                    <label>{{ item.code }}</label>
                    <p>{{ item.name }}</p>
                  </div>
                </auto-complete>
                <auto-complete
                  class="w-100 mt-2"
                  v-model="payment.availableAccId"
                  :disabled="!isEdit"
                  placeholder="Chọn tài khoản"
                  :list="accountList"
                >
                  <div slot="item" slot-scope="{ item }">
                    <p>{{ item.name }}</p>
                  </div>
                </auto-complete>
              </div>
              <i class="mdi mdi-arrow-left mx-2 font-18" />

              <div class="flex flex-1">
                <label>ĐTPN nộp (có)</label>
                <div class="d-flex w-100 align-items-center">
                  <span
                    v-for="t in types"
                    :key="t.key"
                    :class="{
                      'opacity-50 pe-none': newObj.sameTransfer,
                      'tag-primary': t.key == payment.transferType,
                    }"
                    class="tag tag-sm pointer"
                    @click="
                      payment.transferType = t.key;
                      payment.transfer = '';
                      payment.transferCode = '';
                      payment.transferId = '';
                      $forceUpdate();
                    "
                  >
                    {{ t.name }}
                  </span>
                </div>
                <input
                  v-if="payment.transferType == ''"
                  class="form-control"
                  v-model="payment.transfer"
                  @input="payment.transferCode = payment.transfer"
                  placeholder="Nhập tên"
                  key="free"
                  :disabled="newObj.sameTransfer"
                />
                <auto-complete
                  :list="employees"
                  v-if="payment.transferType == 'employee'"
                  v-model="payment.transferId"
                  @input="
                    payment.transfer = employees.find(
                      (a) => a.id == payment.transferId
                    ).name;
                    payment.transferCode = employees.find(
                      (a) => a.id == payment.transferId
                    ).code;
                  "
                  key="employee"
                  placeholder="Chọn nhân viên"
                  class="w-100"
                  :disabled="newObj.sameTransfer"
                >
                  <div slot="item" slot-scope="{ item }">
                    <label>{{ item.code }}</label>
                    <p>{{ item.name }}</p>
                  </div>
                </auto-complete>
                <auto-complete
                  :list="$suppliers"
                  v-if="payment.transferType == 'supplier'"
                  v-model="payment.transferId"
                  @input="
                    payment.transfer = $suppliers.find(
                      (a) => a.id == payment.transferId
                    ).name;
                    payment.transferCode = $suppliers.find(
                      (a) => a.id == payment.transferId
                    ).supplierCode;
                  "
                  placeholder="Chọn nhà cung cấp"
                  key="supplier"
                  :disabled="newObj.sameTransfer"
                  class="w-100"
                >
                  <div slot="item" slot-scope="{ item }">
                    <label>{{ item.supplierCode }}</label>
                    <p>{{ item.name }}</p>
                  </div>
                </auto-complete>
                <input
                  v-if="payment.transferType == 'customer'"
                  v-model="payment.transfer"
                  placeholder="Chọn khách hàng"
                  key="customer"
                  class="form-control"
                  :disabled="newObj.sameTransfer"
                  @focus="selectCustomer('transfer', payment)"
                />
                <auto-complete
                  :list="$customerCompanies"
                  v-if="payment.transferType == 'customerCompany'"
                  v-model="payment.transferId"
                  @input="
                    payment.transfer = $customerCompanies.find(
                      (a) => a.id == payment.transferId
                    ).name;
                    payment.transferCode = $customerCompanies.find(
                      (a) => a.id == payment.transferId
                    ).code;
                  "
                  placeholder="Chọn cty khách hàng"
                  key="customerCompany"
                  :disabled="newObj.sameTransfer"
                  class="w-100"
                >
                  <div slot="item" slot-scope="{ item }">
                    <label>{{ item.code }}</label>
                    <p>{{ item.name }}</p>
                  </div>
                </auto-complete>
                <auto-complete
                  v-model="payment.debtAccId"
                  :disabled="!isEdit"
                  :list="accountList"
                  class="w-100 mt-2"
                  placeholder="Chọn tài khoản"
                >
                  <div slot="item" slot-scope="{ item }">
                    <p>{{ item.name }}</p>
                  </div>
                </auto-complete>
              </div>

              <div class="flex flex-10px" />
              <money-input
                @change="countPrice(true)"
                :disabled="!isEdit"
                v-model="payment.totalPayment"
                class="flex flex-150px form-control text-right"
              />
            </div>
          </div>
          <div>
            <div class="box-headline d-flex align-items-center">
              <check-box
                v-model="newObj.isPayment"
                className="bold"
                title="Thông tin thanh toán"
                :disabled="!isEdit"
              />
              <p></p>
              <a @click="addPaymentDetail()" class="text-primary" v-if="isEdit">
                + Thêm mới
              </a>
            </div>
            <div
              class="box-item d-md-flex align-items-center"
              v-for="(p, index) in newObj.paymentDetails"
              :key="index"
            >
              <div class="d-flex align-items-center mb-2">
                <i
                  v-if="newObj.paymentDetails.length > 1"
                  @click="
                    newObj.paymentDetails = newObj.paymentDetails.filter(
                      (i, idx) => idx != index
                    );
                    countPrice();
                  "
                  class="fa fa-trash pointer text-danger pr-2 font-22"
                />
                <select
                  @change="countPrice()"
                  :disabled="!isEdit"
                  class="custom-select flex flex-1"
                  v-model="p.type"
                >
                  <option v-for="i in $paymentTypes" :key="i.id" :value="i.id">
                    {{ i.name }}
                  </option>
                </select>
              </div>
              <div class="d-md-flex flex-fill d-none" />
              <div class="d-flex align-items-center mb-2">
                <div
                  class="flex flex-30px"
                  v-if="newObj.paymentDetails.length > 1"
                />
                <money-input
                  @change="countPrice()"
                  class="form-control flex flex-2 text-right"
                  v-model="p.totalCash"
                  :disabled="!isEdit"
                />
                <select
                  @change="countPrice()"
                  v-model="p.currencyUnit"
                  :disabled="!isEdit"
                  class="flex flex-1 form-control"
                >
                  <option
                    :value="exchange.currency"
                    :key="exchange.id"
                    v-for="exchange in $exchangeList"
                  >
                    {{ exchange.currency }} ({{
                      $formatMoney(exchange.exchangePrice)
                    }})
                  </option>
                </select>
              </div>
            </div>
            <div class="box-headline flex flex-row align-items-center mt-2">
              <p class="flex flex-1 align-items-end font-16 bold">Tổng nhận</p>
              <p class="flex flex-200px align-items-end font-16 bold">
                {{ $formatMoney(totalReceive) }}
              </p>
            </div>
            <div
              class="w100"
              v-if="totalPayment != totalReceive && newObj.isPayment"
            >
              <div
                class="box-footer flex flex-row"
                v-if="totalPayment > totalReceive"
              >
                <p class="flex flex-1 align-items-end text-danger">
                  Tiền thiếu
                </p>
                <p class="flex flex-200px align-items-end text-danger">
                  {{ $formatMoney(totalReceive - totalPayment) }}
                </p>
              </div>
              <div class="box-item flex flex-row" v-else>
                <p class="flex flex-1 align-items-end text-success">
                  Tổng trả lại
                </p>
                <p class="flex flex-200px align-items-end text-success">
                  {{ $formatMoney(totalPayment - totalReceive) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/services/api";
import AutoComplete from "./AutoComplete.vue";
import CheckBox from "./CheckBox.vue";
import moment from "moment/moment";
// import { logHistory } from "@/services/history";

export default {
  name: "DetailQuickView",
  components: { AutoComplete, CheckBox },
  data: function () {
    return {
      detail: {},
      tabActive: "info",
      isOpen: false,
      type: "income",
      loading: false,
      invoices: [],
      totalPayment: 0,
      totalReceive: 0,
      inputs: [],
      sending: false,
      employees: [],
      rawData: {},
      // tabActive: "info",
      newObj: {
        receiverType: "",
        transferType: "",
        receiver: "",
        transfer: "",
        sameReceiver: true,
        sameTransfer: true,
        startDate: new Date(),
        payments: [],
        paymentDetails: [],
      },
      oldObj: {},
      isEdit: false,
      recordId: "",
      accountList: [],
      contracts: [],
      types: [
        {
          key: "",
          name: "Tự do",
        },
        {
          key: "employee",
          name: "NV",
        },
        {
          key: "customer",
          name: "Khách",
        },
        {
          key: "customerCompany",
          name: "CTY Khách",
        },
        {
          key: "supplier",
          name: "NCC",
        },
      ],
    };
  },
  watch: {
    newObj: {
      handler() {
        this.updatePayment();
      },
      deep: true,
    },
  },

  methods: {
    updatePayment() {
      this.newObj.payments.map((item) => {
        if (this.newObj.sameReceiver) {
          item.receiver = this.newObj.receiver;
          item.receiverId = this.newObj.receiverId;
          item.receiverType = this.newObj.receiverType;
          item.receiverCode = this.newObj.receiverCode;
        }
        if (this.newObj.sameTransfer) {
          item.transfer = this.newObj.transfer;
          item.transferCode = this.newObj.transferCode;
          item.transferId = this.newObj.transferId;
          item.transferType = this.newObj.transferType;
        }
      });
      this.$forceUpdate();
    },
    selectCustomer(type, child) {
      this.$root.selectCustomer.openPopup({}, { isSingle: true }).then((re) => {
        if (child) {
          child[type + "Id"] = re.id;
          child[type + "Code"] = re.customerCode;
          child[type] = re.customerName;
        } else {
          this.newObj[type + "Id"] = re.id;
          this.newObj[type + "Code"] = re.customerCode;
          this.newObj[type] = re.customerName;
          this.newObj[type + "Represent"] = re.customerName;
        }
        this.$forceUpdate();
      });
    },
    addPayment() {
      this.newObj.payments.push({
        debtAccId: "",
        availableAccId: "",
        totalPayment: 0,
        transferType: "",
        receiverType: "",
        transfer: "",
        receiver: "",
        receiverId: "",
        transferId: "",
        receiverCode: "",
        transferCode: "",
      });
      this.updatePayment();
      this.countPrice();
      this.$forceUpdate();
    },

    addPaymentDetail() {
      this.newObj.paymentDetails.push({
        type: "CASH",
        exchangePrice: 0,
        totalCash: 0,
        currencyUnit: this.$currency,
      });
      this.countPrice();
      this.$forceUpdate();
    },

    countPrice(isCountDetail) {
      this.totalPayment = this.newObj.payments.reduce(
        (a, b) => (a += b.totalPayment),
        0
      );
      this.totalReceive = this.newObj.paymentDetails
        .map((i) => {
          i.exchangePrice = this.$exchangeList.find(
            (e) => e.currency == i.currencyUnit
          ).exchangePrice;
          i.totalPayment = i.totalCash * i.exchangePrice;
          return i.totalPayment;
        })
        .reduce((a, b) => (a += b), 0);
      var isAllowSet = false;

      if (
        this.newObj.paymentDetails.length == 1 &&
        this.newObj.paymentDetails[0].currencyUnit == this.$currency
      ) {
        isAllowSet = true;
      }

      if (isCountDetail && isAllowSet) {
        this.newObj.paymentDetails = [
          {
            type: "CASH",
            exchangePrice: 1,
            totalCash: this.totalPayment,
            totalPayment: this.totalPayment,
            currencyUnit: this.$currency,
          },
        ];
        this.totalReceive = this.totalPayment;
      }
    },
    onSubmit() {
      var check = this.newObj.payments.filter(
        (i) => !i.debtAccId || !i.availableAccId || !i.totalPayment
      );
      if (check.length || !this.newObj.payments.length) {
        this.$noti.open("Cần đầy đủ thông tin hạch toán", true);
        return;
      }
      if (this.totalPayment != this.totalReceive && this.newObj.isPayment) {
        this.$noti.open("Thông tin thanh toán cần khớp với hạch toán", true);
        return;
      }
      // this.getContracts();

      const newObj = JSON.parse(JSON.stringify(this.newObj));

      if (!newObj.receiver) {
        this.$noti.open("Thêm thông tin người nộp", true);
        return;
      }

      if (!newObj.transfer) {
        this.$noti.open("Thêm thông tin người nhận", true);
        return;
      }

      // if (
      //   this.recordId &&
      //   !this.detail.isManual &&
      //   this.detail.totalPayment != this.totalPayment
      // ) {
      //   this.$noti.open(
      //     "Thông tin hạch toán cần khớp với tổng thanh toán",
      //     true
      //   );
      //   return;
      // }

      // delete res.address;

      var refs = [];
      if (newObj.transferType && newObj.transferId) {
        refs.push({
          [newObj.transferType + "Id"]: newObj.transferId,
        });
      }
      if (newObj.receiverType && newObj.receiverId) {
        refs.push({
          [newObj.receiverType + "Id"]: newObj.receiverId,
        });
      }

      delete newObj.transferId;
      delete newObj.receiverId;
      delete newObj.transferType;
      delete newObj.receiverType;
      delete newObj.sameReceiver;
      delete newObj.sameTransfer;

      const oldObj = this.oldObj;
      const paymentReqs = this.newObj.payments.map((a) => {
        return {
          id: a.id,
          debtAccId: a.debtAccId,
          availableAccId: a.availableAccId,
          totalPayment: a.totalPayment,
          receiver: a.receiver,
          transfer: a.transfer,
          transferCode: a.transferCode,
          receiverCode: a.receiverCode,
        };
      });

      if (oldObj && oldObj.payments && oldObj.payments.length) {
        oldObj.payments.map((a) => {
          if (!paymentReqs.find((b) => b.id == a.id)) {
            paymentReqs.push({
              id: a.id,
              debtAccId: a.debtAcc.id,
              availableAccId: a.availableAcc.id,
              totalPayment: a.totalPayment,
              receiver: a.receiver,
              transfer: a.transfer,
              transferCode: a.transferCode,
              receiverCode: a.receiverCode,
              isDelete: true,
            });
          }
        });
      }

      const paymentDetailReqs = this.newObj.paymentDetails.map((i) => ({
        id: i.id,
        currencyUnit: i.currencyUnit,
        originalCurrency: i.totalCash,
        exchangePrice: 1,
        totalPayment: i.totalCash * 1,
        isCashPayment: i.type == "CASH",
        cardType: i.type != "CASH" ? i.type.split("&&")[0] : "",
        cardNumber: i.type != "CASH" ? i.type.split("&&")[1] : "",
      }));

      if (oldObj && oldObj.paymentDetails && oldObj.paymentDetails.length > 0) {
        oldObj.paymentDetails.map((a) => {
          if (!paymentDetailReqs.find((b) => b.id == a.id)) {
            paymentDetailReqs.push({
              id: a.id,
              currencyUnit: a.currencyUnit,
              originalCurrency: 0,
              exchangePrice: 1,
              totalPayment: 0,
              isCashPayment: a.isCashPayment,
              cardType: a.cardType,
              cardNumber: a.cardNumber,
              isDelete: true,
            });
          }
        });
      }

      const dataInsert = {
        transfer: newObj.transfer,
        receiver: newObj.receiver,
        // datePayment: newObj.datePayment,
        description: newObj.description,
        address: newObj.address,
        bookNo: newObj.bookNo,
        codeNumber: newObj.codeNumber,
        elementCode: newObj.elementCode,
        elementName: newObj.elementName,
        transferRepresent: newObj.transferRepresent,
        receiverRepresent: newObj.receiverRepresent,
        transferCode: newObj.transferCode,
        receiverCode: newObj.receiverCode,

        contractId: newObj.contractId || undefined,

        startDate: this.$formatDate(newObj.startDate),
        incomeExpenseRef: refs,
        totalPayment: this.totalPayment,
        accountantType: this.type == "income" ? "INCOME" : "EXPENSE",
        paymentReqs: paymentReqs,
        paymentDetailReqs: paymentDetailReqs,
      };
      this.sending = true;

      if (this.recordId) {
        api
          .editIncomeExpense(this.recordId, dataInsert, this.newObj.branches.id)
          .then(() => {
            this.sending = false;
            this.isOpen = false;
            this._ok();
          })
          .catch(() => {
            this.sending = false;
          });
      } else {
        api
          .newIncomeExpense(dataInsert, this.$branchId)
          .then(() => {
            this.sending = false;
            this.isOpen = false;
            this._ok();

            // logHistory([
            //   {
            //     type: "CREATE",
            //     code: r.data.data.code || "",
            //     model: "FINANCE",
            //     label: "Tạo Hạch toán",
            //     newData: "Tạo",
            //     oldData: "",
            //   },
            // ]);
          })
          .catch(() => {
            this.sending = false;
          });
      }
    },
    getAccountList() {
      this.$api
        .findBranchCircularCategory(
          { "branches.id": this.detail.branches.id },
          "id_desc",
          10000,
          0
        )
        .then((res) => {
          this.accountList = res
            .map((i) => {
              return {
                id: i.id,
                code: i.companyCircularCategory.code,
                title: i.companyCircularCategory.name,
                name:
                  i.companyCircularCategory.code +
                  " - " +
                  i.companyCircularCategory.name,
              };
            })
            .filter((a) => a.code)
            .sort((a, b) => (a.code > b.code ? 1 : -1));
        });
    },
    openPopup(detail, isEdit) {
      this.isOpen = true;
      this.type = detail.type || "income";
      this.recordId = detail.id;
      this.isEdit = !detail.id;

      this.employees = this.$branch.employeeBranches.map((i) => ({
        ...i.employees,
        name: i.employees.fullName,
        code: i.employees.employeeCode,
        search: i.employees.employeeCode,
      }));

      this.oldObj = JSON.parse(JSON.stringify(detail));

      if (isEdit) {
        this.isEdit = true;
      }
      // if(this.contracts.length == 0) {
      //   this.getContracts();
      // } 
      // this.getContracts();
      this.newObj = {
        receiverType: "",
        transferType: "",
        receiver: "",
        transfer: "",
        receiverCode: "",
        transferCode: "",
        sameReceiver: true,
        sameTransfer: true,
        startDate: new Date(),
        paymentDetails: [],
        payments: [],
        isPayment: true,
        contractId: undefined,
      };
      if (this.recordId) {
        this.newObj = {
          ...this.newObj,
          ...detail,
          payments: detail.payments.map((a) => ({
            ...a,
            debtAccId: a.debtAcc.id + "",
            availableAccId: a.availableAcc.id + "",
          })),
          paymentDetails: detail.paymentDetails.map((a) => ({
            ...a,
            totalCash: a.totalPayment,
            type: a.isCashPayment ? "CASH" : "CARD",
          })),
          isPayment: detail.paymentDetails.length > 0,
          startDate: moment(detail.startDate).toDate(),
        };
        this.rawData = JSON.parse(JSON.stringify(this.newObj));
        this.detail = JSON.parse(JSON.stringify(detail));
        this.getAccountList();
      } else {
        this.accountList = this.$accountList;
        this.addPayment();
        this.addPaymentDetail();
      }
      this.countPrice();

      return new Promise((resolve, reject) => {
        this._ok = resolve;
        this._cancel = reject;
      });
    },

    closePopup: function () {
      this.isOpen = false;
      this._cancel();
    },
    // getContracts() {
    //   this.$api.getContracts({}).then((res) => {
    //     this.contracts = res.list;
    //   });
    // },
  },
};
</script>
